<template>
	<div>
		<template v-if="network_success">
			<!-- banner -->
			<banner></banner>
			<!-- banner end -->
			
			<div class="line"></div>
			
			<div style="position: relative;width: 1200px;margin: 0 auto;min-height: 700px;padding: 0 0 0 258px;">
				<!-- 康复案例 -->
				<case 
					v-if="nav_index == 0"
					:num="case_num"
					:data="case_detail"
				></case>
				<!-- 康复案例 end -->
				
				<template v-if="nav_index != 0">
					<!-- 治疗流程 -->
					<process></process>
					<!-- 治疗流程 end -->
					
					<!-- 康复数据 -->
					<digital></digital>
					<!-- 康复数据 end -->
				</template>
			</div>
			
			<!-- 浮动导航 -->
			<float-nav :list="nav_list" :fixed="nav_fixed" :index="nav_index" @onClick="handleNavClick"></float-nav>
			<!-- 浮动导航 end -->
		</template>
		
		<!-- 网络出错 -->
		<network-err v-if="!network_success" @onRefresh="handleNetworkRefresh"></network-err>
		<!-- 网络出错 end -->
	</div>
</template>

<script>
	import Banner from './components/banner.vue';
	import FloatNav from './components/float_nav.vue';
	import Case from './components/case.vue';
	import Process from './components/process.vue';
	import Digital from './components/digital.vue';
	import { mapMutations } from 'vuex';
	import Api from '../../../api/api.js';
	
	export default {
		mounted() {
			this.case_id = '';
			this.offset_top = [460, 1111];
			this.listenWindowScroll();
			setTimeout(() => {
				this.init();
			}, 100);
		},
		beforeDestroy() {
			this.removeListenWindowScroll();
		},
		data() {
			return {
				network_success: true,
				nav_list: [],
				nav_fixed: false,
				nav_index: 0,
				case_detail: {},
				case_num: ''
			}
		},
		methods: {
			/*************** @Events *******************/
			// 点击菜单
			handleNavClick(index, case_id, case_num) {
				const that = this;
				let ele = document.documentElement || document.body;
				this.nav_index = index - 1;
				if (index == 1 && this.case_id != case_id) {
					this.case_id = case_id;
					this.getCaseDetail(case_num < 10 ? `0${ case_num }` : `${ case_num }`)
				}
				index == 2 && that.$nextTick(() => {
					ele.scrollTop = that.offset_top[0]
				});
				index == 3 && that.$nextTick(() => {
					ele.scrollTop = that.offset_top[1]
				});
				if (index != 1) {
					this.case_id = '';
					this.case_num = '';
				}
			},
			// 网络错误刷新
			handleNetworkRefresh() {
				this.init();
			},
			
			/*************** @Function *******************/
			// 初始化
			init() {
				const that = this;
				let type = that.$route.query.type || '';
				let ele = document.documentElement || document.body;
				if (type == 'case' || type == '') {
					that.nav_index = 0;
				} else if (type == 'process') {
					that.nav_index = 1;
					that.$nextTick(() => {
						ele.scrollTop = that.offset_top[0];
					});
				} else {
					that.nav_index = 2;
					that.$nextTick(() => {
						ele.scrollTop = that.offset_top[1];
					});
				}
				that.findCaseList();
			},
			// 获取康复数据
			findCaseList() {
				const that = this;
				that.setLoading(true);
				let requestData = {
					type: 2
				};
				Api.findCaseList(requestData).then((res) => {
					if (res.data.success) {
						that.nav_list = res.data.data;
						that.setLoading(false);
						that.network_success = true;
						that.nav_index == 0 && (that.case_id = that.nav_list[0] ? that.nav_list[0].uid : '');
						that.nav_index == 0 && that.getCaseDetail('01');
					} else {
						that.setLoading(false);
						that.network_success = false;
					}
				}, () => {
					that.setLoading(false);
					that.network_success = false;
				});
			},
			// 得到康复案例详情
			getCaseDetail(case_num) {
				const that = this;
				let ele = document.documentElement || document.body;
				that.setLoading(true);
				let requestData = {
					id: that.case_id
				};
				Api.getCaseDetail(requestData).then((res) => {
					if (res.data.success) {
						that.case_num = case_num;
						that.case_detail = res.data.data.now;
						that.$nextTick(() => {
							ele.scrollTop = 0;
						});
						that.setLoading(false);
					} else {
						that.setLoading(false);
						that.swal(res.data.message, {button: false});
					}
				}, (e) => {
					that.setLoading(false);
					that.swal(e.message, {button: false});
				});
			},
			// 监听页面滚动
			listenWindowScroll() {
				window.addEventListener('scroll', this.windowScroll, false);
			},
			// 移除页面滚动监听
			removeListenWindowScroll() {
				window.removeEventListener('scroll', this.windowScroll, false);
			},
			windowScroll() {
				let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				scrollTop >= 454 ? (this.nav_fixed = true) : (this.nav_fixed = false);
				if (this.nav_index != 0) {
					if (scrollTop < this.offset_top[1]) {
						this.nav_index = 1;
					}
					if (scrollTop >= this.offset_top[1]) {
						this.nav_index = 2;
					}
				}
			},
			...mapMutations({
				"setLoading": "setLoading"
			})
		},
		components: {
			Banner,
			FloatNav,
			Case,
			Process,
			Digital
		}
	}
</script>

<style scoped>
	.line{ height: 44px;background: rgb(224, 232, 232); }
</style>
